import { useCallback, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import styled from 'styled-components'

import { Button, PageLoadingSkeleton } from '../../../components/ui'
import { ROUTES } from '../../../constants/routes'
import { getApiErrorMessage } from '../../../utils/apiError'
import { getCurrentLegalDocumentActionStatuses } from '../api/legalDocumentApi'
import {
  hasRequiredLegalActionStatuses,
  LEGAL_ACTION_CONTEXT,
} from '../lib/legalDocuments'

export default function LegalOnboardingRoute({ element }) {
  const [status, setStatus] = useState('loading')
  const [error, setError] = useState('')
  const [reloadKey, setReloadKey] = useState(0)

  const checkOnboarding = useCallback(async () => {
    setStatus('loading')
    setError('')
    try {
      const result = await getCurrentLegalDocumentActionStatuses(
        LEGAL_ACTION_CONTEXT.EXISTING_USER_ONBOARDING,
      )
      const statuses = result.data?.legalDocumentActionStatuses || []
      const needsOnboarding = statuses.length === 0
        || !hasRequiredLegalActionStatuses(statuses)
      setStatus(needsOnboarding ? 'required' : 'ready')
    } catch (requestError) {
      setError(getApiErrorMessage(requestError, '약관 및 정책 상태를 확인하지 못했어요.'))
      setStatus('error')
    }
  }, [])

  useEffect(() => {
    checkOnboarding()
  }, [checkOnboarding, reloadKey])

  if (status === 'loading') {
    return <PageLoadingSkeleton label="약관 및 정책 상태를 확인하는 중" />
  }

  if (status === 'error') {
    return (
      <GateState role="alert">
        <p>{error}</p>
        <Button $variant="secondary" onClick={() => setReloadKey(key => key + 1)}>
          다시 시도
        </Button>
      </GateState>
    )
  }

  if (status === 'required') {
    return <Navigate to={ROUTES.POLICY_CONSENT} replace />
  }

  return element
}

const GateState = styled.div`
  display: grid;
  min-height: min(520px, calc(100dvh - 180px));
  padding: 32px;
  align-content: center;
  justify-items: center;
  gap: 16px;
  background: ${({ theme }) => theme.colors.background};

  > div { width: min(560px, 100%); }
  p { margin: 0; color: ${({ theme }) => theme.colors.textMuted}; }
`
